
import {
  toLakh,
  sumThis,
  numberWithCommas,
  toCurrency,
  sumOf,
  countOf,
  sumAndCountOf,
  showSum,
  showCount,
  showSumAndCount,
  percentChange,
  showBlank,
  changeClassTo,
  mobileNumber,
  panCardNumber,
  validEmail,
  adharNumber,
  allDirectQueries
} from "../../commonFunctions";
import { controls } from "../../controls"

const rp206 = {
  label: "A/C Freeze Register",
  pageLabel: "A/C Freeze Register",
  starting: true,
  url: "rp206",
  pageType: "history",
  form: [],
  filter: [
    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),

    ...controls.showData({ tab: "filter", data: "branch_display", width: "col-sm-2", name: "branch_display", }),

    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", star: true, label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", isRequired: true, width: "col-sm-2", sendToServer: { dataType: 'product', sendData: [{ varname: 'product_group', fixed: "Deposit" }] } }),
    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "product_code_display", name: "product_code_display", }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-2", label: "Account Number From " }),
    ...controls.numberOnly({ tab: "filter", width: "col-sm-2", placeHolder: "Account Number From", name: "account_number_from" }),
    ...controls.numberOnly({ tab: "filter", width: "col-sm-2", placeHolder: "Account Number To", name: "account_number_to" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    ...controls.magicDateLabel({ tab: "filter", label: "From To Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "from_date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "to_date", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2", label: "Transaction Type", }),


    ...controls.FreezeTypes({ tab: "filter", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2", label: "Amount From To", }),
    ...controls.numberOnly({ tab: "filter", width: "col-sm-2", placeHolder: "Amount From", name: "amount_from" }),
    ...controls.numberOnly({ tab: "filter", width: "col-sm-2", placeHolder: "Amount To", name: "amount_to" }),

  ],
  history: {
    perPage: 10,
    reportHeader: "Freeze Accounts",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: false,
    filterable: true,
    displayColumns: [
      {
        Header: "Freeze Date",
        accessor: "freeze_date",

      },
      {
        Header: "A/C No",
        accessor: "account_number",
        width: 150
      },

      {
        Header: "CIN",
        accessor: "cin",
      },
      {
        Header: "Account Name",
        accessor: "account_name_display"
      },
      {
        Header: "Freeze Amount",
        accessor: "amount",
        type: "currency",
      },
      {
        Header: "Freeze Type",
        accessor: "freeze_type",

      },
      {
        Header: "Reason",
        accessor: "reason",
      },
      {
        Header: "UnFreeze Date",
        accessor: "unfreeze_date",

      },
      {
        Header: "Remarks",
        accessor: "remarks",

      },
      {
        Header: "Unfreeze By",
        accessor: "unfreeze_by",
      },
      {
        Header: "Freeze by",
        accessor: "freeze_by",
      },



    ]
  }
}

export default rp206;